module.exports = __webpack_public_path__ + "static/media/PDF_file_icon.svg.404fc7fb.png";